export default "__VITE_ASSET__CkDY_HCA__"